import { render, staticRenderFns } from "./my_bnps_project.vue?vue&type=template&id=1160ee18&scoped=true&"
import script from "./my_bnps_project.vue?vue&type=script&lang=js&"
export * from "./my_bnps_project.vue?vue&type=script&lang=js&"
import style0 from "./my_bnps_project.vue?vue&type=style&index=0&id=1160ee18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1160ee18",
  null
  
)

export default component.exports